import {
  Col,
  Stepper,
  useMatchMediaTierProp,
} from "@george-labs.com/design-system"
import { LoanCaseOfferStateEnum } from "@smartx/mikro-vt-client-api"
import { useCallback, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router"

export enum OFFER_STEPS {
  Calculator = "calculator",
  SoftFacts = "softfacts",
  Evaluation = "evaluation",
  Signers = "signers",
  Accounts = "accounts",
  Summary = "summary",
  Documents = "documents",
  Appointment = "appointment",
  Success = "succes",
}

interface IOfferStep {
  route: string
  step: string
  offerStates: LoanCaseOfferStateEnum[]
  visibility: "N/A" | "HIDDEN" | "VISIBLE"
}

export const STEP_MATRIX: IOfferStep[] = [
  {
    route: "",
    step: "welcome",
    offerStates: ["CALCULATOR"],
    visibility: "N/A",
  },
  {
    route: OFFER_STEPS.Calculator,
    step: OFFER_STEPS.Calculator,
    offerStates: [],
    visibility: "VISIBLE",
  },
  {
    route: OFFER_STEPS.SoftFacts,
    step: OFFER_STEPS.SoftFacts,
    offerStates: ["SOFT_FACTS"],
    visibility: "VISIBLE",
  },
  {
    route: OFFER_STEPS.Evaluation,
    step: OFFER_STEPS.Evaluation,
    offerStates: [
      "EVALUATION_IN_PROGRESS",
      "EVALUATION_MODIFICATION",
      "EVALUATION_SUCCESS",
    ],
    visibility: "VISIBLE",
  },
  {
    route: "info/failed",
    step: "failed",
    offerStates: ["EVALUATION_FAILED"],
    visibility: "N/A",
  },
  {
    route: "info/error",
    step: "error",
    offerStates: ["EVALUATION_ERROR"],
    visibility: "N/A",
  },
  {
    route: OFFER_STEPS.Signers,
    step: OFFER_STEPS.Signers,
    offerStates: ["SIGNERS"],
    visibility: "VISIBLE",
  },
  {
    route: OFFER_STEPS.Accounts,
    step: OFFER_STEPS.Accounts,
    offerStates: ["ACCOUNTS"],
    visibility: "VISIBLE",
  },
  {
    route: OFFER_STEPS.Summary,
    step: OFFER_STEPS.Summary,
    offerStates: ["SUMMARY"],
    visibility: "VISIBLE",
  },
  {
    route: OFFER_STEPS.Documents,
    step: OFFER_STEPS.Documents,
    offerStates: ["DOCUMENTS"],
    visibility: "VISIBLE",
  },
  {
    route: "info/status",
    step: OFFER_STEPS.Appointment,
    offerStates: ["APPOINTMENT"],
    visibility: "HIDDEN",
  },
  {
    route: OFFER_STEPS.Appointment,
    step: OFFER_STEPS.Appointment,
    offerStates: [],
    visibility: "N/A",
  },
]

const STEPS: string[] = STEP_MATRIX?.filter(
  (el) => el.visibility !== "N/A",
)?.map((el) => el.step)

const OfferStepper = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const [stepIdx, setStepIdx] = useState(null)
  const [step, setStep] = useState<IOfferStep>(null)

  useEffect(() => {
    const route = location.pathname?.replace("/offer/", "")
    const step = STEP_MATRIX.find((s) => s.route === route)

    if (step) {
      setStepIdx(STEPS?.indexOf(step.step))
      setStep(step)
    }
  }, [location])

  const getCurrentStepLabel = useCallback(() => {
    return step
      ? `${stepIdx + 1}/${STEPS.length} ${t("offers.stepper.step")} - ${t("offers.page." + step.step)}`
      : ""
  }, [stepIdx, step, t])

  const stepperContent =
    step?.visibility === "VISIBLE" ? (
      <Stepper
        currentStepIndex={stepIdx}
        steps={STEPS}
        compact={true}
        compactLabel={getCurrentStepLabel()}
      />
    ) : (
      <></>
    )

  const offerStepperContent = useMatchMediaTierProp({
    xs: <>{stepperContent}</>,
    md: (
      <Col
        sm={{
          size: 6,
          offset: 3,
        }}
      >
        {stepperContent}
      </Col>
    ),
  })

  if (step?.visibility !== "VISIBLE") {
    return
  }

  return <>{offerStepperContent}</>
}

export default OfferStepper
